import {Chromeless} from '@freckle/classroom/ts/hooks/chromeless/component'
import {LoggedRoute} from './../../logged-route'
import {
  MathAdaptiveAssignmentsHandler,
  MathAssessmentAssignmentsHandler,
  MathFactPracticeHandler,
  MathNumberFactsAssignmentsHandler,
  MathTargetedAssignmentsHandler,
  ChromelessMathTargetedAssignmentsHandler,
  ChromelessMathTargetedDepthOfKnowledgePracticeAssignmentsHandler,
  MathTargetedDepthOfKnowledgePracticeAssignmentsHandler,
  MathFocusSkillsPracticeAssignmentsHandler
} from './lazy'

export const routerV2MathAssign = [
  {
    path: '/assignments/adaptive',
    element: <LoggedRoute component={MathAdaptiveAssignmentsHandler} />
  },
  {
    path: '/assignments/number-facts',
    element: <LoggedRoute component={MathNumberFactsAssignmentsHandler} />
  },
  {
    path: '/assignments/targeted',
    element: <LoggedRoute component={MathTargetedAssignmentsHandler} />
  },
  {
    path: '/chromeless/assignments/targeted',
    element: (
      <Chromeless>
        <LoggedRoute
          dashboardType="minimal"
          fullScreen
          component={ChromelessMathTargetedAssignmentsHandler}
        />
      </Chromeless>
    )
  },
  {
    path: '/assignments/assessments',
    element: <LoggedRoute component={MathAssessmentAssignmentsHandler} />
  },
  {
    path: '/assignments/fact-practice',
    element: <LoggedRoute component={MathFactPracticeHandler} />
  },
  {
    path: '/assignments/targeted-depth-of-knowledge-practice',
    element: <LoggedRoute component={MathTargetedDepthOfKnowledgePracticeAssignmentsHandler} />
  },
  {
    path: '/chromeless/assignments/targeted-depth-of-knowledge-practice',
    element: (
      <Chromeless>
        <LoggedRoute
          dashboardType="minimal"
          fullScreen
          component={ChromelessMathTargetedDepthOfKnowledgePracticeAssignmentsHandler}
        />
      </Chromeless>
    )
  },
  {
    path: '/assignments/math-focus-skills-practice',
    element: <LoggedRoute component={MathFocusSkillsPracticeAssignmentsHandler} />
  }
]
